// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import IconSrc from '../../../assets/images/question-white.svg';

const PopupS = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Triangle: styled.div`
    width: 0;
    margin-left: 90px;
    border-style: solid;
    border-width: 9px 7px 0 7px;
    border-color: #434343 transparent transparent transparent;
    border-radius: 1px;
  `,
  Content: styled.p`
    width: 285px;
    padding: 12px 15px;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    background: #434343;
    border-radius: 4px;
  `,
}

const Popup: React.FC<React.ComponentPropsWithRef<'div'>> = (props) => {
  return (
    <PopupS.Container {...props}>
      <PopupS.Content>
        <FormattedMessage id="D037" />
      </PopupS.Content>
      <PopupS.Triangle />
    </PopupS.Container>
  )
}

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
    margin-left: 8px;
  `,
  Icon: styled.img.attrs({ src: IconSrc })`
    width: 24px;
    cursor: pointer;
  `,
  Popup: styled(Popup)`
    position: absolute;
    left: -85px;
    top: -68px;
  `,
}

const DownloadNotion: React.FC<React.ComponentPropsWithRef<'div'>> = props => {
  const [isPopupShow, setPopupShow] = useState(false);
  return (
    <S.Container>
      <S.Icon
        onMouseLeave={() => { setPopupShow(false) }}
        onMouseEnter={() => { setPopupShow(true) }}
      />
      {isPopupShow && <S.Popup />}
    </S.Container>
  )
}

export { DownloadNotion as default };
